export const DEFAULT_BRIEF =
  "Sell field sales management SaaS to D2C brands in Bangalore. \u20B98,000/month per team. Target companies with 10\u201350 field reps.";

export const FALLBACK_DATA = {
  scout: {
    targets: [
      {
        name: "Lenskart",
        why: "Operates 2,000+ franchise stores across India with a field rep in every location \u2014 managing them is a daily operational fire drill",
        score: 5,
        insight: "Lenskart is doubling Tier 2 expansion this year and hiring 3,000+ field reps. Their current tool is a mix of Excel and WhatsApp \u2014 it\u2019s already breaking.",
        url: "https://www.lenskart.com",
        email: "info@lenskart.com",
        emailSource: "inferred",
      },
      {
        name: "Mamaearth",
        why: "India\u2019s first profitable D2C unicorn now runs 5,000+ offline touchpoints \u2014 offline is now 35% of revenue and the field team is growing fast",
        score: 4,
        insight: "Mamaearth\u2019s offline ops head has been vocal on LinkedIn about rep visibility being their #1 operational gap. Right timing, right person to call.",
        url: "https://mamaearth.in",
        email: "internationalsupport@mamaearth.com",
        emailSource: "scraped",
      },
      {
        name: "Sugar Cosmetics",
        why: "Bangalore-based D2C brand with 500+ dedicated field reps managing 50,000+ retail display points across India",
        score: 4,
        insight: "Sugar just closed a Series D and stated offline retail as their primary growth lever. They will double their field team in 6 months \u2014 without better tooling, it will break.",
        url: "https://www.sugarcosmetics.com",
        email: "hello@sugarcosmetics.com",
        emailSource: "scraped",
      },
    ],
  },
  outreach: {
    target_name: "D2C Brand Ops Head",
    subject: "Your field team is costing you 20% extra",
    body: "Saw your D2C brand scaling fast across Karnataka \u2014 field ops at that stage usually means your best rep is now a manager with no tools.\n\nWe help field teams of 10\u201350 reps cut coordination time by 3 hours/day \u2014 that\u2019s \u20B940,000/month in recovered productivity per team.\n\nThree Bangalore brands switched from WhatsApp management to us in the last quarter.\n\nWorth a 20-minute walkthrough this week \u2014 I can show you exactly what your team\u2019s current leakage looks like.",
  },
  objection: {
    battles: [
      {
        objection: "We already manage our team on WhatsApp, it works fine for us.",
        response:
          "WhatsApp works until it doesn\u2019t \u2014 and usually it stops working right when you\u2019re scaling. We integrate with WhatsApp so your team doesn\u2019t change how they work, but you get full visibility on top of it.",
      },
      {
        objection: "\u20B98000 per month is too expensive for us right now.",
        response:
          "At \u20B98000/month, you recover that cost if we save one field rep just 90 minutes a week \u2014 most teams recover it in week one. We can start with a 30-day pilot so you see the number before committing.",
      },
      {
        objection: "We tried a tool before and the team didn\u2019t adopt it.",
        response:
          "Adoption fails when you ask field reps to change their workflow \u2014 we don\u2019t. Reps keep working how they work, the visibility layer sits above it. Your manager sees everything, reps change nothing.",
      },
    ],
  },
};
